import React from "react";
import { Box } from "@mui/material";
import {
  COLORS,
  SIZES,
  Dot,
  formatValueOrDash,
} from "../SkillSheetMainSectionUi";
import { FONT_SIZE } from "../../../../constants/fontSizes";

/**
 * SkillSheetMainSummaryMobile
 * スマホ表示用：テーブルを使わず、縦積みレイアウトで表示
 */
export default function SkillSheetMainSummaryMobile({
  workHistory,
  phases,
  displayValues,
  isPublicPage,
}) {
  /**
   * 1行分の表示（ラベル + 値）
   * プロジェクト名 / 役割 / 規模 / 業種 / 開発手法 用
   */
  const Row = ({ label, value, masked = false, sx }) => {
    const displayValue = formatValueOrDash(value);

    return (
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "92px 1fr",
          borderBottom: `1px solid ${COLORS.border}`,
          ...sx,
        }}
      >
        {/* ラベル */}
        <Box
          sx={{
            backgroundColor: COLORS.labelBg,
            borderRight: `1px solid ${COLORS.border}`,
            p: 0.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            fontWeight: 700,
            fontSize: FONT_SIZE.XXS,
            lineHeight: 1.2,
          }}
        >
          {label}
        </Box>

        {/* 値 */}
        <Box
          sx={{
            backgroundColor: COLORS.valueBg,
            p: 0.5,
            fontSize: FONT_SIZE.XXS,
            color: masked ? "transparent" : COLORS.text,
            textShadow: masked ? "0 0 8px rgba(0,0,0,0.9)" : "none",
            userSelect: masked ? "none" : "text",
            whiteSpace: "pre-line",
          }}
        >
          {displayValue}
        </Box>
      </Box>
    );
  };

  return (
    <>
      {/* ===== 基本情報 ===== */}
      <Box
        sx={{
          border: `1px solid ${COLORS.border}`,
          borderRadius: `${SIZES.radius}px`,
          overflow: "hidden",
          backgroundColor: COLORS.valueBg,
        }}
      >
        <Row label="期間" value={displayValues.period} />
        <Row
          label="プロジェクト名"
          value={displayValues.name}
          masked={isPublicPage}
        />
        <Row label="役割" value={displayValues.roles} />
        <Row label="規模" value={displayValues.scale} />
        <Row label="業種" value={displayValues.industry} />
        <Row
          sx={{ borderBottom: "none" }}
          label="開発手法"
          value={displayValues.developmentMethods}
        />
      </Box>

      {/* ===== 工程 ===== */}
      <Box sx={{ mt: 1 }}>
        <Box
          sx={{
            border: `1px solid ${COLORS.border}`,
            borderRadius: `${SIZES.radius}px`,
            overflow: "hidden",
            backgroundColor: COLORS.valueBg,
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(6, 1fr)",
            }}
          >
            {phases.map((phase) => (
              <Box
                key={phase.key}
                sx={{
                  borderRight: `1px solid ${COLORS.border}`,
                  "&:nth-of-type(6n)": { borderRight: "none" },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: COLORS.phaseHeaderBg,
                    borderBottom: `1px solid ${COLORS.border}`,
                    textAlign: "center",
                    fontWeight: 700,
                    fontSize: FONT_SIZE.XXS,
                    lineHeight: 1.2,
                    py: 1,
                    whiteSpace: "pre-line",
                  }}
                >
                  {phase.label}
                </Box>

                <Box sx={{ py: 1.5 }}>
                  {workHistory.phasesActive?.[phase.key] && <Dot active />}
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </>
  );
}
